import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { AppLinksService } from '../../api/services/app-links.service';
import { BusinessAccountCtaComponent } from '../../partials/components/business-account-cta/business-account-cta.component';
import {
  RelatedPage,
  RelatedPagesComponent,
} from '../../partials/components/related-pages/related-pages.component';

@Component({
  selector: 'app-aml-check',
  imports: [MatIcon, RouterLink, BusinessAccountCtaComponent, RelatedPagesComponent],
  templateUrl: './aml-check.component.html',
  styleUrl: './aml-check.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmlCheckComponent {
  protected readonly appLinks = inject(AppLinksService);

  protected readonly relatedPages: RelatedPage[] = [
    {
      link: '/transaction-monitoring',
      anchor: 'Crypto transaction monitoring',
      text: 'Keep the wallets you have already checked under continuous watch, with alerts when their activity changes.',
    },
    {
      link: '/aml-api',
      anchor: 'AML API for crypto screening',
      text: 'Run the same checks from inside your own product — one integration instead of four provider contracts.',
    },
    {
      link: '/wallet-screening',
      anchor: "Crypto wallet screening",
      text: "The address-level view of the same data: what a wallet has been close to, and how that verdict is reached.",
    },
    {
      link: '/solutions/otc-desk',
      anchor: "AML screening for OTC desks",
      text: "How a desk fits a counterparty check between the quote and the settlement, without slowing the trade down.",
    },
    {
      link: '/pricing',
      anchor: 'Pricing and plans',
      text: 'Pro, Corporate and Enterprise plans, each with all four AML providers through one integration; per-report rates appear in your account after registration.',
    },
  ];
}
